import { __assign, __awaiter, __decorate, __extends, __generator } from "tslib";
import * as React from 'react';
import { Collection, dtoToCollectionProps } from './collection';
import { getTagsDataBySlugs } from '../../api/api';
import { FetchStatus } from '../view-rapper';
import { biLogger } from '../../bi';
import { config } from '../../config';
import { withMarketplaceStore, } from '../../component-decorators/with-marketplace-store';
import { WithFetcher, } from '../../component-decorators/with-fetcher';
import { composer } from '../../component-decorators/composer';
import { CenteredLoader } from '../centered-loader';
import { ErrorPageType, Origin } from '../..';
import { CollectionSEO } from './collection-seo';
import { useConfigContext } from '../../config-context';
import { ErrorPageContainer } from '../error-page/error-page-container';
import { getReferralInfo, getWidgetReferral } from '../../common/bi-events';
import { withExperiments } from '../../component-decorators/with-experiments';
var CollectionContainer = /** @class */ (function (_super) {
    __extends(CollectionContainer, _super);
    function CollectionContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.sendPageViewBi = function (dto) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
            var pageViewParams = {
                app_id: null,
                market: config.originForBI,
                navigation_source: _this.props.marketplaceStore.route.referral,
                tag_name: (_d = (_c = (_b = (_a = dto === null || dto === void 0 ? void 0 : dto.tagsAndSubCategories) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.tag) === null || _c === void 0 ? void 0 : _c.slug) === null || _d === void 0 ? void 0 : _d.replace(/-/g, '_'),
                tag_type: (_g = (_f = (_e = dto === null || dto === void 0 ? void 0 : dto.tagsAndSubCategories) === null || _e === void 0 ? void 0 : _e[0].tag) === null || _f === void 0 ? void 0 : _f.type) === null || _g === void 0 ? void 0 : _g.toLowerCase(),
                msid: _this.props.marketplaceStore.metaSiteId,
                referral_info: getReferralInfo((_j = (_h = _this.props.marketplaceStore) === null || _h === void 0 ? void 0 : _h.route) === null || _j === void 0 ? void 0 : _j.referral, (_k = _this.props.marketplaceStore) === null || _k === void 0 ? void 0 : _k.prevRoute),
                search_term: (_m = (_l = _this.props.marketplaceStore) === null || _l === void 0 ? void 0 : _l.prevRoute) === null || _m === void 0 ? void 0 : _m.query,
                widget_referral: getWidgetReferral(),
            };
            // tslint:disable-next-line: no-floating-promises
            biLogger.appMarketPageView(pageViewParams);
        };
        _this.state = { isFetchingData: FetchStatus.FETCHING };
        console.log("marketplace-component/src/components/collection/collection-container.tsx file - line 54 - " + Date.now());
        return _this;
    }
    CollectionContainer.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.sendPageViewBi(this.props.fetchData);
                return [2 /*return*/];
            });
        });
    };
    CollectionContainer.prototype.componentDidUpdate = function (prevProps) {
        return __awaiter(this, void 0, void 0, function () {
            var useInReview;
            var _this = this;
            return __generator(this, function (_a) {
                useInReview = this.props.experiments &&
                    this.props.experiments.enabled('specs.marketplace.UseInReview');
                if (this.props.slug !== prevProps.slug) {
                    // tslint:disable-next-line: no-floating-promises
                    this.props.reFetch(function () {
                        return getTagsDataBySlugs([_this.props.slug], useInReview, _this.props.locale, _this.props.countryCode, true, true);
                    });
                    this.sendPageViewBi(this.props.fetchData);
                }
                return [2 /*return*/];
            });
        });
    };
    CollectionContainer.prototype.render = function () {
        console.log("marketplace-component/src/components/collection/collection-container.tsx file - line 113 - " + Date.now());
        return React.createElement(Collection, __assign({}, dtoToCollectionProps(this.props.fetchData)));
    };
    CollectionContainer = __decorate([
        withMarketplaceStore,
        withExperiments
    ], CollectionContainer);
    return CollectionContainer;
}(React.Component));
function isValidCollectionPageData(fetchData) {
    return (fetchData &&
        fetchData.tagsAndSubCategories &&
        fetchData.tagsAndSubCategories[0]);
}
export var CollectionFetcher = composer()
    .withExperiments()
    .compose(function (_a) {
    var slug = _a.slug, experiments = _a.experiments;
    // tslint:disable-next-line:react-hooks-nesting
    var _b = useConfigContext(), locale = _b.locale, countryCode = _b.countryCode, rpcClient = _b.rpcClient;
    var useInReview = experiments && experiments.enabled('specs.marketplace.UseInReview');
    console.log("marketplace-component/src/components/collection/collection-container.tsx file - line 139 - " + Date.now());
    return (React.createElement(WithFetcher, { loader: React.createElement(CenteredLoader, null), initialFetch: function () {
            return getTagsDataBySlugs([slug], useInReview, locale, countryCode, true, true, rpcClient);
        }, fetchMemoizationId: "collection-" + slug + "-" + locale }, function (_a) {
        var fetchData = _a.fetchData, reFetch = _a.reFetch;
        return (React.createElement(CollectionContainerWrapper, { slug: slug, useInReview: useInReview, locale: locale, countryCode: countryCode, fetchData: fetchData, reFetch: reFetch, useNewApi: true, sortTagsByGeo: true }));
    }));
});
var CollectionContainerWrapper = function (_a) {
    var slug = _a.slug, useInReview = _a.useInReview, locale = _a.locale, countryCode = _a.countryCode, reFetch = _a.reFetch, fetchData = _a.fetchData, useNewApi = _a.useNewApi, sortTagsByGeo = _a.sortTagsByGeo;
    React.useEffect(function () {
        reFetch(function () {
            return getTagsDataBySlugs([slug], useInReview, locale, countryCode, useNewApi, sortTagsByGeo);
        });
    }, [slug, locale]);
    console.log("marketplace-component/src/components/collection/collection-container.tsx file - line 196 - " + Date.now());
    return isValidCollectionPageData(fetchData) ? (React.createElement(React.Fragment, null,
        config.origin === Origin.STANDALONE && (React.createElement(CollectionSEO, { collectionName: fetchData.tagsAndSubCategories[0].tag.name, collectionDesc: fetchData.tagsAndSubCategories[0].tag.description, collectionSlug: slug })),
        React.createElement(CollectionContainer, { slug: slug, fetchData: fetchData, reFetch: reFetch, locale: locale, countryCode: countryCode }))) : (React.createElement(ErrorPageContainer, { slug: slug, errorPageType: ErrorPageType.NOT_FOUND }));
};
//# sourceMappingURL=collection-container.js.map